import React from "react";
import { useState,useEffect } from "react";
import { configData } from "../config";
import { useNavigate,useLocation ,useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Loading from './Loading';
import SalespersonSidebar from './SalespersonSidebar';
import './classes/DeleteCoupon.css';

const couponsList = [
    {id:"1", coupon_name: "22NHL", coupon_status:{label: "Active", value: "1"}, couponUsage: 0},
    {id:"2", coupon_name: "22NHLDRAFT", coupon_status:{label: "Active", value: "1"}, couponUsage: 1},
    {id:"3", coupon_name: "AA150", coupon_status:{label: "Active", value: "1"}, couponUsage: 1},
]

const DeleteCoupon = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const { id } = useParams(); 
    const location = useLocation();
    const loggedin_uid = localStorage.getItem('drupal_uid');
    const[error,setError] = useState({});
    const user = couponsList.find(item => item.id === id);

    const initialCouponForm = {
        coupon_code:  "",
        status:  "1",
    }

    const [isLoading, setIsLoading] = useState(true); 
    const [formData, setFormData] = useState(initialCouponForm);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
        
    };

     useEffect(() => {
            Promise.all([
                    getcoupondetails(id)
            ])
            .then(() => {
            
                setIsLoading(false);
            })
            
        },[]);
        async function getcoupondetails(id) {
            
               
                    const response = await fetch(
                         app_url+'smwwcommercecoupon/getcoupondetails?id='+id,
                        {
                            method: "GET",
          
                            headers: {
                            'Content-Type': 'application/json',
                            },
                        }
                    )           
                    const responsedata = await response.json();
                    if(responsedata.data.msg === "Success") {
                        const updatedForm = {
           coupon_code:responsedata.data.result.coupon_code,
           status:responsedata.data.result.status,
            id:id
         };
         
         setFormData(updatedForm);
                    }
               
            }
        const handleDelete = async (e) => {
            e.preventDefault(); // prevent page reload
    
           const response = await fetch(app_url+'smwwcommercecoupon/deletecoupondetails', {
          method: 'POST',
          body: JSON.stringify(formData),
          headers: {
            'Content-Type': 'application/json',
          },
          });
          const data = await response.json();
          if(data.data.msg === "Success") {
            navigate('/admin/smww-commerce/coupon-list', { state: { message: data.data.result } });
          }
          if(data.data.msg === "Error") {
                    setError(data.data.result);
                }
        
    
        };
    

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    {loggedin_uid && !Number.isNaN(loggedin_uid) ? (
                        <>
                            <Helmet><title>Delete Coupon</title></Helmet>
                            <div className="left"></div>
                            <div className="center left-center">
                                {error.length > 0 && (
          <div className="set-message-error" style={{ padding:"10px 10px 10px 50px",background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`}}>
           {error.map((item, index) => {
           return <>{item}<br /></>
          
        })}  
          </div>
        )}
                                <div className="delete-coupon-container">
                                    <form>
                                        <label>Coupon Code <span className="form-required">*</span></label> 
                                        <input 
                                            style={{width:"30%"}} 
                                            type="text" 
                                            name="coupon_code" 
                                            id="coupon_code" 
                                            value={formData.coupon_code}
                                            onChange={handleChange}
                                            required disabled
                                        />

                                        <label>Coupon Status <span className="form-required">*</span></label> 
                                        <select 
                                            id="status" 
                                            name="status"
                                            value={formData.status}
                                            onChange={handleChange} disabled
                                        >
                                            <option value="1">Active</option>
                                            <option value="2">Disabled</option>
                                            <option value="3">Archive</option>
                                        </select> 

                                        <input 
                                            type="button" 
                                            name="" 
                                            value="Delete coupon"
                                            style={{width:"155px", height: "30px"}} 
                                            className="form-submit" 
                                            onClick={handleDelete}
                                        />

                                    </form>
                                </div>
                            </div>
                            <div className="right">
                                <SalespersonSidebar />
                            </div>
                        </>
                    ) : (
                        <><p>You are not authorized</p></>   
                    )}
                </div>
            )}
        </>
    );
};
export default DeleteCoupon;